import React from 'react';
import { connect } from 'react-redux';
import { get, isNil } from 'lodash';
import moment from 'moment';
// NOTE: this is not used directly, but has to be included
// noinspection ES6UnusedImports
import momentDurationFormatSetup from 'moment-duration-format'; // eslint-disable-line no-unused-vars

import { feRebookDirtyTime } from 'actions/ui.actions';
import TruncatedText from 'components/generic/TruncatedText.component';
import CurrencySign from 'components/price/CurrencySign.component';
import useAppointmentPermissions from 'hooks/useAppointmentPermissions.hook';
import { withTranslation } from 'providers/GILT.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import { formatLocalizedTime } from 'utils/date/format.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

import { changeDuration, changeProcessing, changeService, editPrice, removeService, updateService } from 'booking/actions';
import Counter from 'booking/components/common/Counter';
import { StylistList } from 'booking/components/common/StylistList';
import TimeSlot from 'booking/components/common/TimeSlot';
import { determineIfCustom } from 'booking/utils';
import HtmlPopup from 'common/HtmlPopup';

export const fromPropsToDetermineIfCustomOptions = (props) => ({
  categoryId: get(props, 'service.category'),
  stylistId: get(props, 'service.stylist_id'),
  categories: props.categoryServices ? props.categoryServices : [],
  stylists: props.stylistList ? props.stylistList : [],
  field: '', // correct value TBD outside this function
  value: NaN, // correct value TBD outside this function
});

const L = logger('DropdownService--booking'); // eslint-disable-line no-unused-vars

const fromStartTimeToDisplayText = (start, t) => {
  const formattedStartTime = formatLocalizedTime(start);

  if (formattedStartTime === '12:00 AM' || 5 > moment(start).get('hour')) {
    L.debug('fromStartTimeToDisplayText()', 'before select time', formattedStartTime, '<-', start);
    return t('scheduler.booking.dropdownService.selectTime');
  }

  if (parseInt(formattedStartTime.split(' ')[0].split(':')[1], 10) % 15 !== 0) {
    L.debug('fromStartTimeToDisplayText()', 'no user selected', formattedStartTime, '<-', start);
    return t('scheduler.booking.dropdownService.selectTime');
  }

  L.debug('fromStartTimeToDisplayText()', formattedStartTime, '<-', start);
  return formattedStartTime;
};

class DropdownService extends React.Component {
  static defaultProps = { index: 0 };

  constructor(props) {
    super(props);
    let selectedStylist = '';
    if (this.props.service && this.props.service.stylist_id) {
      const selectedStylistArr = this.props.stylistList.filter((s) => s.id.toString() === this.props.service.stylist_id.toString());
      selectedStylist = selectedStylistArr.length && selectedStylistArr[0].user_name;
    }
    this.state = {
      openDropdown: 3,
      priceLabel: props.t('scheduler.booking.dropdownService.price'),
      price: 0,
      processingMinutes: 0,
      durationMinutes: 0,
      selectedStylist,
      editingStaff: false,
      editingTime: false,
      editingPrice: false,
      startTimeSelected: false,
    };
    this.priceRef = React.createRef();
  }

  UNSAFE_componentWillMount() {
    this.fillState(this.props);
    let selectedStylist;
    if (this.props.stylistList.filter((s) => s.status === 'active').length === 1) {
      selectedStylist = this.props.stylistList.filter((s) => s.status === 'active')[0].user_name;
      this.setState({ selectedStylist });
      /* const { id } = this.props.stylistList.filter(
        s => s.user_name.toUpperCase() === selectedStylist.toUpperCase() && s.status === 'active',
      )[0]; */
      const { service } = this.props;
      service.stylist_id = this.props.stylistList.filter((s) => s.status === 'active')[0].id;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fillState(nextProps);
    let selectedStylist = '';
    if (nextProps.service && nextProps.service.stylist_id) {
      selectedStylist = nextProps.stylistList.filter((s) => s.id === nextProps.service.stylist_id)[0].user_name;
    }
    // if only has one stylist, select it
    if (nextProps.stylistList.filter((s) => s.status === 'active').length === 1) {
      selectedStylist = nextProps.stylistList.filter((s) => s.status === 'active')[0].user_name;
      /* const { id } = this.props.stylistList.filter(
        s => s.user_name.toUpperCase() === selectedStylist.toUpperCase() && s.status === 'active',
      )[0]; */
      const { service } = this.props;
      service.stylist_id = nextProps.stylistList.filter((s) => s.status === 'active')[0].id;
    }
    if (selectedStylist) {
      this.setState({ selectedStylist });
    }
  }

  onClick = (e) => {
    if (this.state.editingPrice) {
      if (this.priceRef && this.priceRef.current && (e.target.className.indexOf('dropdown-menu') >= 0 || e.target.className.indexOf('show-edit-done') >= 0)) {
        this.setState({ editingPrice: false });
      }
    }
  };

  getCategoryName = (id) => {
    const { categoryServices } = this.props;
    const category = categoryServices.find((x) => x.id === id);
    if (category) {
      return category.name;
    }
    return '';
  };

  fillState = (props) => {
    const { price, processing, duration } = props.service;
    const processingMinutes = moment.duration(processing).asMinutes();
    const durationMinutes = moment.duration(duration).asMinutes();
    this.setState({ price, processingMinutes, durationMinutes });
  };

  changePrice = (price) => {
    if (price === '') {
      this.setState({ price: null });
      return;
    }

    const custom = determineIfCustom({
      ...fromPropsToDetermineIfCustomOptions(this.props),
      field: 'price',
      value: price,
    });

    this.setState({ price });
    const id = this.props.service.id.toString();
    this.props.editPrice({ price, id, custom });
  };

  changeProcessingTime = (processingMinutes) => {
    const id = this.props.service.id ? this.props.service.id : this.props.service.local_id;
    const processing = moment.duration(processingMinutes, 'minutes');

    const custom = determineIfCustom({
      ...fromPropsToDetermineIfCustomOptions(this.props),
      field: 'processing',
      value: processingMinutes,
    });

    this.setState({ processingMinutes });
    this.props.changeProcessing({ processing, id, custom });
  };

  changeDurationTime = (durationMinutes) => {
    if (durationMinutes <= 0) {
      return;
    }

    const id = this.props.service.id ? this.props.service.id : this.props.service.local_id;
    const duration = moment.duration(durationMinutes, 'minutes');

    const custom = determineIfCustom({
      ...fromPropsToDetermineIfCustomOptions(this.props),
      field: 'duration',
      value: durationMinutes,
    });

    this.setState({ durationMinutes });
    this.props.changeDuration({ duration, id, custom });
  };

  changeStylist = (name) => {
    if (this.props.removedService) {
      const popProps = {
        title: this.props.t('scheduler.booking.dropdownService.htmlPopup.title'),
        content: this.props.t('scheduler.booking.dropdownService.htmlPopup.content'),
      };
      // FIXME: replace with state and SalonModal and remove file for HtmlPopup
      HtmlPopup(true, popProps);
      return;
    }

    this.setState({ selectedStylist: name });

    if (isNil(this.props.stylistList)) return;

    const filteredStylists = this.props.stylistList.filter((s) => s.status === 'active' && s.user_name && s.user_name.toUpperCase() === name.toUpperCase());

    if (isFullArray(filteredStylists.length)) return;

    const { id } = filteredStylists[0];
    const { service } = this.props;
    service.stylist_id = id;

    // book by clicking button start time is 0 hour before set time
    if (this.props.index === 0 && this.state.startTimeSelected) {
      this.props.updateService(service);
    } else if (moment(service.start_time).get('hour') !== 0) {
      this.props.updateService(service);
    }
  };

  changStartTime = (ev) => {
    const { removedService, updateService, stylistList, service, t } = this.props;

    if (removedService) {
      return void HtmlPopup(true, {
        title: t('scheduler.booking.dropdownService.htmlPopup.title'),
        content: t('scheduler.booking.dropdownService.htmlPopup.content'),
      });
    }

    const hour = ev?.value?.hour;
    const minute = ev?.value?.minute;

    service.start_time = service.start_time ? moment(service.start_time) : moment();
    service.start_time.set('hour', hour);
    service.start_time.set('minute', minute);
    service.start_time.set('second', 0);
    service.start_time.set('millisecond', 0);

    if (service.start_time && this.state.selectedStylist && !service.stylist_id) {
      service.stylist_id = stylistList.filter((s) => s.status === 'active' && s.user_name.toUpperCase() === this.state.selectedStylist.toUpperCase())[0].id;
    }

    this.setState({ startTimeSelected: true }, () => void updateService(service));
  };

  showMoreOrRemove = () => {
    // default to 3, with word 'remove', 1 with word 'EDIT'
    if (this.state.openDropdown !== 1) {
      this.removeService();
    } else if (this.state.openDropdown === 1) {
      this.toggleMenu(3);
    }
  };

  showHideStafflist = () => void this.setState({ editingStaff: !this.state.editingStaff });
  showHideTimeslots = () => {
    const isEditingTime = this.state.editingTime;
    const feRebookDirtyTime = this.props.feRebookDirtyTime;

    L.debug('showHideTimeslots()', 'feRebookDirtyTime calling', { isEditingTime, feRebookDirtyTime });
    if (isEditingTime) {
      feRebookDirtyTime({ dirty: true });
    }
    this.setState({ editingTime: !isEditingTime });
  };

  showPriceEditing = (b) => {
    let editingPrice;
    if (typeof b === 'boolean') {
      editingPrice = b;
    } else {
      editingPrice = !this.state.editingPrice;
    }
    this.setState({ editingPrice });
    if (editingPrice) {
      if (this.priceRef && this.priceRef.current) {
        this.priceRef.current.focus();
      }
    }
    this.setState({ editingPrice });
  };

  removeService = () => {
    if (this.props.service.id) {
      this.props.removeService(this.props.service.id, false);
    } else {
      this.props.removeService(this.props.service.local_id, true);
    }
  };

  toggleMenu = (level) => {
    if (level === 6) {
      // this.resetHeight(180, 6);
      const { price, processing, duration } = this.props.service;
      const processingMinutes = moment.duration(processing).asMinutes();
      const durationMinutes = moment.duration(duration).asMinutes();
      this.setState({
        price,
        processingMinutes,
        durationMinutes,
      });
    } /* else if (level === 3) {
      this.resetHeight(-180, 3);
    } else if (level === 1) {
      this.resetHeight(-174, 3);
    } */
    this.setState({ openDropdown: level });
  };

  render() {
    const { durationMinutes, processingMinutes } = this.state;
    const {
      service: { name },
      borderColor,
      backgroundColor,
      t,
    } = this.props;
    const removeBtnName = this.state.openDropdown === 1 ? t('common.buttons.editUpp') : t('common.buttons.removeUpp');
    const editDoneStaffBtnName = this.state.editingStaff ? t('common.buttons.doneUpp') : t('common.buttons.editUpp');
    const editDoneTimeBtnName = this.state.editingTime ? t('common.buttons.doneUpp') : t('common.buttons.editUpp');
    const editDonePriceBtnName = this.state.editingPrice ? t('common.buttons.doneUpp') : t('common.buttons.editUpp');
    const staffRightClassName = this.state.editingStaff ? 'staff-button-right active' : 'staff-button-right';
    const startRightClassName = this.state.editingTime ? 'staff-button-right active' : 'staff-button-right';
    const priceRightClassName = this.state.editingPrice ? 'staff-button-right active' : 'staff-button-right';

    const staffRightStyle = this.state.editingStaff
      ? {
          color: borderColor,
          boxShadow: `0px 0px 0px 1px ${borderColor}`,
          backgroundColor: '#fff',
        }
      : { color: '#192340', border: 'none', backgroundColor: '#f5f5f5' };
    const startRightStyle = this.state.editingTime
      ? {
          color: borderColor,
          boxShadow: `0px 0px 0px 1px ${borderColor}`,
          backgroundColor: '#fff',
        }
      : { color: '#192340', border: 'none', backgroundColor: '#f5f5f5' };
    const priceRightStyle = this.state.editingPrice
      ? {
          color: borderColor,
          boxShadow: `0px 0px 0px 1px ${borderColor}`,
          backgroundColor: '#fff',
        }
      : { color: '#192340', border: 'none', backgroundColor: '#f5f5f5' };
    const priceInputStyle = this.state.editingPrice
      ? { color: borderColor }
      : {
          color: '#192340',
          border: 'none',
          backgroundColor: '#f5f5f5',
        };
    const dropdownContainerClass = this.state.openDropdown === 3 ? 'dropdown colored' : this.state.openDropdown === 6 ? 'dropdown colored expanded' : 'dropdown colored collapsed';

    const serviceStartTime = this.props.service.start_time;

    return (
      <div
        data-bem="DropdownService--booking"
        data-tag={fromAnyToTrimmed(this.props.tag)}
        className={dropdownContainerClass}
        style={{ borderColor }}
        onClick={(e) => {
          e.stopPropagation();
          this.onClick(e);
        }}
        role="button"
        tabIndex={-1}
      >
        <div className={this.state.openDropdown === 1 ? 'dropdown-button' : 'dropdown-button expanded'} style={{ borderColor }}>
          <span className="category-bulet-color" style={{ backgroundColor }} />
          <span className="name">{name}</span>
          <div className="info">
            <span>
              <CurrencySign value={this.state.price} />
            </span>
            <span>{moment.duration(durationMinutes, 'minutes').format('h [hr] m [mins]', { trim: 'both final' })}</span>
            <span className="text-trim"> {this.getCategoryName(this.props.service.category)}</span>
          </div>
          <div className="edit-done" style={{ color: borderColor }} role="button" tabIndex={0} onClick={() => this.showMoreOrRemove()}>
            {removeBtnName}
          </div>
        </div>
        {this.state.openDropdown > 1 && (
          <div data-bem="DropdownService__open-dropdown-menu" className="dropdown-menu-2" style={{ borderColor }}>
            <div className="show-edit-done" style={{ color: borderColor }} role="button" tabIndex={0} onClick={this.props.permIsCreatePersonalOnly ? undefined : () => this.showHideStafflist()}>
              <div className="current-value">{t('scheduler.booking.dropdownService.staffMember')}</div>
              <div className={staffRightClassName} style={staffRightStyle}>
                <div style={{ backgroundColor: '#f5f5f5' }}>
                  <TruncatedText max={28} suffix="..." value={this.state.selectedStylist || t('scheduler.booking.dropdownService.selectStylist')} />
                </div>
                {!this.props.permIsCreatePersonalOnly && (
                  <div style={{ backgroundColor: '#f5f5f5' }}>
                    <TruncatedText max={24} suffix="..." value={editDoneStaffBtnName} />
                  </div>
                )}
              </div>
            </div>
            {this.state.editingStaff && !this.props.permIsCreatePersonalOnly && (
              <StylistList selectedStylist={this.state.selectedStylist} changeStylist={this.changeStylist} stylistList={this.props.stylistList} service={this.props.service} />
            )}
            {this.state.selectedStylist && (
              <div data-bem="DropdownService__start-time" className="show-edit-done" style={{ color: borderColor }} role="button" tabIndex={0} onClick={() => this.showHideTimeslots()}>
                <div data-bem="DropdownService__start-time-label" className="current-value">
                  {t('scheduler.booking.dropdownService.startTime')}
                </div>
                <div data-bem="DropdownService__start-time-info" className={startRightClassName} style={startRightStyle}>
                  <div style={{ backgroundColor: '#f5f5f5' }}>{fromStartTimeToDisplayText(serviceStartTime, t)}</div>
                  <div style={{ backgroundColor: '#f5f5f5' }}>{editDoneTimeBtnName}</div>
                </div>
              </div>
            )}
            {this.state.editingTime && (
              <TimeSlot selectedTime={serviceStartTime} service={this.props.service} openingHours={this.props.openingHours} onSelect={this.changStartTime} selectedDate={this.props.selectedDate} />
            )}
            {this.state.openDropdown === 3 && (
              <div
                className="show-more-less"
                style={{ color: borderColor }}
                role="button"
                tabIndex="-1"
                onClick={() => {
                  this.toggleMenu(6);
                }}
              >
                <span>{t('scheduler.booking.dropdownService.editPriceButton')}</span>
                <span>{t('scheduler.booking.dropdownService.editTimingsButton')}</span>
              </div>
            )}
          </div>
        )}
        {this.state.openDropdown === 6 && (
          <div className="dropdown-menu" style={{ borderColor }}>
            <div
              className="show-edit-done"
              role="button"
              tabIndex={0}
              // onBlur={() => this.showPriceEditing(false)}
              // onClick={() => this.showPriceEditing()}
            >
              <div className="current-value" style={{ color: borderColor }}>
                {this.state.priceLabel} ({t('scheduler.booking.dropdownService.in')} <CurrencySign />)
              </div>
              <div className={priceRightClassName} style={priceRightStyle}>
                <input
                  type="number"
                  onChange={(e) => {
                    this.changePrice(e.target.value);
                  }}
                  // onBlur={() => this.showPriceEditing(false)}
                  onClick={() => this.showPriceEditing()}
                  className="pull-right input-default i-sm"
                  value={this.state.price}
                  style={priceInputStyle}
                  ref={this.priceRef}
                  readOnly={this.props.permCanEditPrice === false}
                  disabled={this.props.permCanEditPrice === false}
                />
                <div className="price-btn" style={{ backgroundColor: '#f5f5f5' }} onClick={() => this.showPriceEditing()} role="button" tabIndex={-2}>
                  {editDonePriceBtnName}
                </div>
              </div>
            </div>
            <Counter
              labelColor={borderColor}
              changeCounter={this.changeDurationTime}
              counterLabel={t('scheduler.booking.dropdownService.applicationTime')}
              time={durationMinutes}
              timeInHour={moment.duration(durationMinutes, 'minutes').format('h [hr] m [mins]', { trim: 'both final' })}
              disabled={this.props.permCanEditDuration === false}
            />
            <Counter
              labelColor={borderColor}
              changeCounter={this.changeProcessingTime}
              counterLabel={t('scheduler.booking.dropdownService.processingTime')}
              time={processingMinutes}
              timeInHour={moment.duration(processingMinutes, 'minutes').format('h [hr] m [mins]', { trim: 'both final' })}
              disabled={this.props.permCanEditDuration === false}
            />
            <div className="bottom-show-less">
              <span role="button" tabIndex={0} onClick={() => this.toggleMenu(3)} className="show-less" style={{ color: borderColor }}>
                {t('common.buttons.doneUpp')}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const DropdownServiceConnected = connect(
  (state) => ({
    categoryServices: state.salon.services.categories,
    openingHours: state.currentSalon.openingHours,
    selectedDate: state.scheduler.selectedDate,
  }),
  mapActionsToDispatchToProps({
    removeService,
    changeService,
    changeDuration,
    changeProcessing,
    editPrice,
    updateService,
    feRebookDirtyTime,
  }),
)(withTranslation()(DropdownService));

const DropdownServiceWithPermissions = (props) => {
  const { canEditPrice, canEditDuration, isCreatePersonalOnly } = useAppointmentPermissions();
  return <DropdownServiceConnected {...props} permCanEditPrice={canEditPrice} permCanEditDuration={canEditDuration} permIsCreatePersonalOnly={isCreatePersonalOnly} />;
};

export default DropdownServiceWithPermissions;
